var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-8"},[_c('i-input',_vm._g({attrs:{"suffix":"ios-search","placeholder":_vm.$t("shared.component.filter.search"),"clearable":true,"value":_vm.value}},_vm.$listeners))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }